module.exports = __webpack_public_path__ + "img/MC4.32d7cb08.webp";